// import { tns } from "../../../../themes/ett-core-theme/node_modules/tiny-slider/src/tiny-slider";
// import { tns } from '../../../../themes/ett-core-theme/assets/scripts/vendors';
const bannerBlockApp = (function () {
  return {
    sliderInfo: "",
    init: function (slideElement) {
      if (slideElement instanceof jQuery) {
        slideElement = slideElement.find(".banner-block-slider")[0];
      }
      import(/* webpackChunkName: "tiny-slider" */"../../../../themes/ett-core-theme/node_modules/tiny-slider/src/tiny-slider")
        .then(({ tns }) => {
          slideElement.classList.remove('loading-block');
          const slide = tns({
            container: slideElement,
            items: 1,
            slideBy: 'page',
            gutter: 20,
            mode: "carousel",
            autoplayButtonOutput: false,
            controlsText: [
              '<span class="sr-only">Slide Precedente</span><i class="bi bi-chevron-left"></i>',
              '<span class="sr-only">Slide Successiva</span><i class="bi bi-chevron-right"></i>',
            ],
            swipeAngle: false,
            speed: 300,
            controls: true,
            responsive: {
              1100: {
                swipeAngle: 30,
                items: slideElement.getAttribute('data-per-slide'),
              },
            },
            onInit: (e) => {
              bannerBlockApp.sliderInfo = e;
            },
          });
          if (slide) {
            bannerBlockApp.sliderInfo = slide.getInfo();
            let start = false;
            slide.events.on("transitionEnd", (info, eventName) => {
              if (start) return;
              const slides = [...slideElement.querySelectorAll('.lazy-image')];
              start = true;
              slideElement.classList.remove('loading-block');
              slides.forEach((sl) => {
                sl.classList.remove("lazy");
              });
            });
            slide.goTo('first');
          } else {
            slideElement.classList.remove('loading-block');
          }
        })

    },
  };
})();

{
  const sliders = document.querySelectorAll(".banner-block .banner-block-slider");
  if (sliders) {
    sliders.forEach((slider) => {
      bannerBlockApp.init(slider);
    });
  }
}


(function ($) {
  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=ett-banner-block",
      bannerBlockApp.init
    );
  }
})(jQuery);

export default bannerBlockApp;
